import { forwardRef } from 'react';
import classNames from 'classnames';
import PropTypes from 'prop-types';
import { PopUpMobile } from '@bwoty-web/styleguide';

import styles from './LargePopup.scss';

const LargePopup = forwardRef((props, ref) => {
  const { isOpen, onClose, header, children } = props;

  const c = classNames(styles.root, {
    [styles.isOpen]: isOpen,
  });

  return (
    <div ref={ref} className={c}>
      <PopUpMobile header={header} close={onClose} closed={!isOpen} className={styles.popUp}>
        {children}
      </PopUpMobile>
    </div>
  );
});

LargePopup.propTypes = {
  isOpen: PropTypes.bool,
  onClose: PropTypes.func,
  header: PropTypes.node,
  children: PropTypes.node,
};

export default LargePopup;
